import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import type { LinkTargetType, LinkRelType } from './config';

/**
 * Shared base class providing the common link properties for
 * se-link, se-file-link, and se-full-width-button.
 *
 * Not registered as a custom element — extend it and provide a render().
 */
export class SeLinkBase extends LitElement {
  /**
   * Link url
   */
  @property({ type: String, attribute: 'link-href' })
  linkHref: string | boolean = false;

  /**
   * Link text
   */
  @property({ type: String, attribute: 'link-text' })
  linkText: string | boolean = false;

  /**
   * Link target
   */
  @property({ type: String, attribute: 'link-target' })
  linkTarget: LinkTargetType;

  /**
   * Link rel
   */
  @property({ type: String, attribute: 'link-rel' })
  linkRel: LinkRelType;
}
